import { combineReducers } from "redux";
import AppReducer from '../../Modules/Common/App/Redux/Reducer';
import AuthReducer from '../../Modules/Common/Auth/Redux/Reducer';
import ThemesReducer from '../../Modules/Core/Themes/Redux/Reducer';
import WebAnalyzerReducer from '../../Modules/Tools/WebAnalyzer/Redux/Reducer';
import ToolsReducer from '../../Modules/Tools/Redux/Reducer';

export const publicReducer = combineReducers({
    app: AppReducer,
    auth: AuthReducer,
    webAnalyzers: WebAnalyzerReducer,
    tools: ToolsReducer,
})

export const privateReducer = combineReducers({
    app: AppReducer,
    auth: AuthReducer,
})

export const officeReducer = combineReducers({
    app: AppReducer,
    auth: AuthReducer,
    themes: ThemesReducer,
})
